import { CommonModule } from '@angular/common';
import { Component, Input, OnDestroy, OnInit, inject } from '@angular/core';
import { NavigationEnd, Router, RouterLink, RouterLinkActive } from '@angular/router';
import {IonButton,IonButtons,IonHeader,IonIcon,IonMenuButton,IonTitle,IonToolbar,} from '@ionic/angular/standalone';
import { Subscription, filter } from 'rxjs';
import { Helper } from '../../common/services/helper';
import { SettingsStateService } from '../../services/settings-state.service';

@Component({
  selector: 'app-site-header',
  standalone: true,
  imports: [CommonModule,RouterLink,RouterLinkActive,IonButton,IonButtons,IonHeader,IonIcon,IonMenuButton,IonTitle,IonToolbar,],
  templateUrl: './site-header.component.html',
  styleUrls: ['./site-header.component.scss'],
})
export class SiteHeaderComponent implements OnInit, OnDestroy {
  @Input() title = 'Safarizine';
  @Input() backLink?: string;

  private helper = inject(Helper);
  private router = inject(Router);
  private settingsState = inject(SettingsStateService);

  defaultHighlightNotes = 'This website is online for demo purposes only. Content, booking details, and availability are sample information.';
  settings$ = this.settingsState.settings$;
  navItems: Array<{ title: string; url: string }> = [];

  private routerSubscription?: Subscription;

  private publicNavItems = [
    { title: 'Home', url: '/home' },
    { title: 'About', url: '/about' },
    { title: 'Amenities', url: '/amenities' },
    { title: 'Experience', url: '/experience' },
    { title: 'Offers', url: '/offers' },
    { title: 'Check Availability', url: '/login' },
  ];

  private userNavItems = [
    { title: 'Home', url: '/home' },
    { title: 'About', url: '/about' },
    { title: 'Amenities', url: '/amenities' },
    { title: 'Experience', url: '/experience' },
    { title: 'Offers', url: '/offers' },
    { title: 'Dashboard', url: '/dashboard' },
    { title: 'Profile', url: '/profile' },
    { title: 'Logout', url: '/logout' },
  ];

  ngOnInit() {
    this.updateNavigation();
    this.routerSubscription = this.router.events
      .pipe(filter((event): event is NavigationEnd => event instanceof NavigationEnd))
      .subscribe(() => this.updateNavigation());
  }

  ngOnDestroy() {
    this.routerSubscription?.unsubscribe();
  }

  get bookingInfoLink() {
    return this.isLoggedIn() ? '/view-booking' : '/booking-info';
  }

  private updateNavigation() {
    this.navItems = this.isLoggedIn() ? this.userNavItems : this.publicNavItems;
  }

  private isLoggedIn() {
    const userData = this.helper.getUserData();
    const userToken = this.helper.getUserToken();
    return !!userData && !!userToken;
  }
}
